// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6529) return "static/chunks/6529-d40cc391f7d96861.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5936":"27870da29bc9d7b8","9426":"eb27b776ffbc9159"}[chunkId] + ".js";
};